import { signal } from "zyra";
import { Button, Card, Badge, Input, Textarea, Select, Dialog } from "@zyra/ui";

export function UIFormExample() {
  const name = signal("My next project");
  const open = signal(false);
  const saved = signal(false);
  return (
    <div class="ui-form-example">
      <Card>
        <div class="ui-card-heading">
          <h2>Make it yours.</h2>
          <Badge variant="success">Zyra UI</Badge>
        </div>
        <p>
          Real components, ready to style. Try the controls and preview both
          themes.
        </p>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            saved.value = true;
          }}
        >
          <label for="ui-project">Project name</label>
          <Input
            id="ui-project"
            required
            value={name.value}
            onInput={(event) => {
              name.value = event.currentTarget.value;
              saved.value = false;
            }}
          />
          <label for="ui-category">Project type</label>
          <Select id="ui-category">
            <option>Website</option>
            <option>Dashboard</option>
            <option>Local-first app</option>
          </Select>
          <label for="ui-description">Description</label>
          <Textarea id="ui-description" placeholder="What are you building?" />
          <div class="ui-actions">
            <Button type="submit">Save project</Button>
            <Button
              variant="secondary"
              onClick={() => {
                open.value = true;
              }}
            >
              Open dialog
            </Button>
            <Button variant="ghost" disabled>
              Disabled
            </Button>
          </div>
          <p role="status" class="ui-status">
            {saved.value
              ? `Preview saved: ${name.value}`
              : "This is a local UI preview; no data is sent."}
          </p>
        </form>
      </Card>
      <Dialog
        open={open.value}
        onOpenChange={(value) => {
          open.value = value;
        }}
        aria-labelledby="ui-dialog-title"
        aria-describedby="ui-dialog-description"
      >
        <h2 id="ui-dialog-title">A space for your ideas</h2>
        <p id="ui-dialog-description">
          This dialog keeps keyboard focus inside, closes with Escape, and
          returns focus to its trigger.
        </p>
        <div class="ui-actions">
          <Button
            autofocus
            onClick={() => {
              open.value = false;
            }}
          >
            Got it
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
